import { Typography } from "antd";
import { getDefaultCertificateTexts } from "./certificate-document";

const { Title, Text, Paragraph } = Typography;

export default function CertificateEditablePreview({ data, overrides, onChange }) {
  const { student = {}, training, school, type, duration, endDate, colors, schoolLogo, location } = data || {};
  const isVacation = type === "vacation";

  const defaults = getDefaultCertificateTexts({ type, duration, endDate, location, training, school, student });

  const val = (key) => (overrides?.[key]?.trim() ? overrides[key] : defaults[key]);
  const update = (key) => (value) => onChange({ ...overrides, [key]: value });

  const primary = colors?.primary || "#3b82f6";
  const secondary = colors?.secondary || "#7c3aed";

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "297 / 210",
        background: "#fff",
        overflow: "hidden",
        borderRadius: 4,
        boxShadow: "0 0 0 1px #f0f0f0",
      }}
    >
      <div style={{ position: "absolute", top: "50%", right: 0, width: 20, height: "45%", background: secondary }} />
      <div style={{ position: "absolute", top: "50%", left: 0, width: 20, height: "45%", background: primary }} />
      <div
        style={{
          position: "absolute",
          inset: "6px 10px",
          border: `2px solid ${primary}`,
          borderBottomColor: secondary,
          borderLeftColor: secondary,
          pointerEvents: "none",
        }}
      />

      {schoolLogo && (
        <img
          src={schoolLogo}
          alt="logo"
          style={{ position: "absolute", top: 14, left: 20, width: 34, height: 34, objectFit: "contain" }}
        />
      )}
      <img
        src="/img/logo-purple-H.png"
        alt="bignova"
        style={{ position: "absolute", top: 12, right: 20, width: 80, objectFit: "contain" }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "34px 60px",
          textAlign: "center",
        }}
      >
        <Title level={4} editable={{ onChange: update("title"), tooltip: false }} style={{ color: primary, marginBottom: 8 }}>
          {val("title")}
        </Title>

        <Text style={{ fontSize: 11 }}>
          {isVacation
            ? `Nous soussignés, ${school?.name || "Bignova Learning"}, attestons par la présente que :`
            : "Nous, soussignés, certifions par la présente que :"}
        </Text>

        {!isVacation && (
          <>
            <Text
              editable={{ onChange: update("name"), tooltip: false }}
              style={{ fontSize: 16, fontWeight: "bold", fontStyle: "italic", color: primary, marginTop: 8, display: "block" }}
            >
              {val("name")}
            </Text>
            <Text
              editable={{ onChange: update("birthDateLine"), tooltip: false }}
              style={{ fontSize: 11, marginTop: 4, display: "block" }}
            >
              {val("birthDateLine")}
            </Text>
          </>
        )}

        <Paragraph
          editable={{ onChange: update("mainText"), tooltip: false }}
          style={{ fontSize: 11, marginTop: 10, maxWidth: 480, textAlign: "justify" }}
        >
          {val("mainText")}
        </Paragraph>

        {!isVacation && (
          <Text
            editable={{ onChange: update("endDateText"), tooltip: false }}
            style={{ fontSize: 11, marginTop: 4, display: "block" }}
          >
            {val("endDateText")}
          </Text>
        )}

        <Text
          editable={{ onChange: update("footerText"), tooltip: false }}
          type="secondary"
          style={{ fontSize: 8, marginTop: 8, display: "block" }}
        >
          {val("footerText")}
        </Text>

        {isVacation && (
          <Text
            editable={{ onChange: update("locationDateLine"), tooltip: false }}
            style={{ fontSize: 11, alignSelf: "flex-end", marginTop: 10 }}
          >
            {val("locationDateLine")}
          </Text>
        )}
      </div>

      <div
        style={{
          position: "absolute",
          bottom: 60,
          left: 60,
          right: 60,
          display: "flex",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: "bold", marginBottom: 20 }}>Signature du Directeur</div>
          <div style={{ width: 100, height: 1, background: "#333" }} />
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: "bold", marginBottom: 20 }}>Cachet de l'École</div>
          <div style={{ width: 100, height: 1, background: "#333" }} />
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 10, left: 0, right: 0, textAlign: "center" }}>
        <div style={{ fontSize: 9, color: primary, letterSpacing: 1 }}>BIGNOVALEARNING.COM</div>
      </div>
    </div>
  );
}
